import Lottie from "lottie-react";
import peppaSpinner from "../../assets/animations/peppa_spinner.json";

export default function PeppaSpinner() {
    return (
        <div className="loading">
            <Lottie
                animationData={peppaSpinner}
                loop={true}
                autoplay={true}
                style={{ height: 200, width: 200 }}
            />
            {/* <p>Chargement...</p> */}
        </div>
    );
}